import { render, staticRenderFns } from "./EvaCrmPage.vue?vue&type=template&id=364e1cc6&"
import script from "./EvaCrmPage.vue?vue&type=script&lang=js&"
export * from "./EvaCrmPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports